import { useFeatureFlags, useFeatureFlagsWithPrefs } from '@fs/zion-flags'
import chatLog, { LOG_LEVEL } from '../global/chatLog'

export default function useChatFlags() {
  const {
    messaging_chat_askUsAnything,
    messaging_chat_join_leave_typing_for_all,
    messaging_chat_log_error,
    messaging_chat_log_info,
    messaging_chat_log_log,
    messaging_chat_log_my_user,
    messaging_chat_log_warn,
    messaging_chat_red_dot,
    messaging_chat_create_public_group,
    messaging_chat_disconnect_inactive_websockets,
    messaging_chat_disconnect_inactive_websockets_timeout,
    messaging_chat_remove_channel_watch,
    messaging_chat_query_unreads,
    messaging_chat_use_improved_red_dot_api,
    messaging_chat_show_embedded_fallback_for_all,
    messaging_chat_anonymous_connect,
    messaging_chat_on_demand_translations,
    messaging_chat_new_autoscrolling,
    messaging_chat_multiselect_channels,
  } = useFeatureFlags([
    'messaging_chat_askUsAnything',
    'messaging_chat_join_leave_typing_for_all',
    'messaging_chat_log_error',
    'messaging_chat_log_info',
    'messaging_chat_log_log',
    'messaging_chat_log_my_user',
    'messaging_chat_log_warn',
    'messaging_chat_red_dot',
    'messaging_chat_create_public_group',
    'messaging_chat_disconnect_inactive_websockets',
    'messaging_chat_disconnect_inactive_websockets_timeout',
    'messaging_chat_remove_channel_watch',
    'messaging_chat_query_unreads',
    'messaging_chat_use_improved_red_dot_api',
    'messaging_chat_show_embedded_fallback_for_all',
    'messaging_chat_anonymous_connect',
    'messaging_chat_on_demand_translations',
    'messaging_chat_new_autoscrolling',
    'messaging_chat_multiselect_channels',
  ])

  const { data, loading, error } = useFeatureFlagsWithPrefs(
    [
      'messaging_chat_aua_button',
      'messaging_chat_browse_expo_hall',
      'messaging_chat_browse_sessions',
      'messaging_chat_helper',
    ],
    null,
    { userPreferences: ['fslabs.labs'] }
  )

  if (error) {
    chatLog({ msg: 'Error fetching chat flags', level: LOG_LEVEL.ERROR, error, component: '[useChatFlags]' })
  }

  return {
    chatBrowseExpoHallIsOn: !loading ? !!data.messaging_chat_browse_expo_hall?.isOn : false,
    chatBrowseSessionsIsOn: !loading ? !!data.messaging_chat_browse_sessions?.isOn : false,
    messagingChatAUAButtonIsOn: !loading ? !!data.messaging_chat_aua_button?.isOn : false,
    messagingChatHelperIsOn: !loading ? !!data.messaging_chat_helper?.isOn : false,
    chatAskUsAnythingIsOn: !!messaging_chat_askUsAnything?.isOn,
    messagingChatJoinLeaveTypingForAllIsOn: !!messaging_chat_join_leave_typing_for_all?.isOn,
    messagingChatLogErrorIsOn: messaging_chat_log_error?.isOn,
    messagingChatLogInfoIsOn: messaging_chat_log_info?.isOn,
    messagingChatLogLogIsOn: messaging_chat_log_log?.isOn,
    messagingChatLogMyUserIsOn: messaging_chat_log_my_user?.isOn,
    messagingChatLogWarnIsOn: messaging_chat_log_warn?.isOn,
    messagingChatRedDotConfig: messaging_chat_red_dot?.config,
    messagingChatCreatePublicGroupIsOn: !!messaging_chat_create_public_group?.isOn,
    messagingChatDisconnectInactiveWebsocketsIsOn: !!messaging_chat_disconnect_inactive_websockets?.isOn,
    messagingChatDisconnectInactiveWebsocketsTimeout: messaging_chat_disconnect_inactive_websockets_timeout?.config,
    messagingChatRemoveChannelWatchIsOn: !!messaging_chat_remove_channel_watch?.isOn,
    messagingChatQueryUnreadsIsOn: !!messaging_chat_query_unreads?.isOn,
    messagingChatUseImprovedRedDotApiIsOn: !!messaging_chat_use_improved_red_dot_api?.isOn,
    messagingChatShowEmbeddedFallbackForAllIsOn: !!messaging_chat_show_embedded_fallback_for_all?.isOn,
    messagingChatAnonymousConnectIsOn: !!messaging_chat_anonymous_connect?.isOn,
    messagingChatOnDemandTranslationsIsOn: !!messaging_chat_on_demand_translations?.isOn,
    messagingChatNewAutoscrollingIsOn: !!messaging_chat_new_autoscrolling?.isOn,
    messagingChatMultiselectChannelsIsOn: !!messaging_chat_multiselect_channels?.isOn,
  }
}
